import { WebFooterType } from '@/types/WebFooter';
import { CoreSiteBaseModel } from './CoreSiteBaseModel';
import { Locale } from '@/helpers/LangHelper';

class WebFooterModel extends CoreSiteBaseModel<WebFooterType> {
    constructor() {
        super('global-footer-structure');
    }

    public async getPageFooter(locale: Locale) {
        const footers = await this.find(locale);
        const globalFooter = footers.find((footer) => footer.name.toLowerCase().startsWith('global'));
        const regionalFooter = footers.find((footer) => footer.name.toLowerCase().startsWith('regional'));

        return {
            global: globalFooter?.data?.footers || [],
            regional: regionalFooter?.data?.footers || [],
        };
    }
}

export default new WebFooterModel();
